/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { BlogPost } from '../types';
import { CDN_URLS, OCI_FOLDERS } from '../config';

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    titleKey: 'blog_post_1_title',
    dateKey: 'blog_post_1_date',
    excerptKey: 'blog_post_1_excerpt',
    contentKey: 'blog_post_1_content',
    imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}city/schwarz_sacco_bern.png`,
    authorId: 'elara-vance',
    date: '2026-02-26',
    dateModified: '2025-10-26',
    externalUrl: 'https://diary.constantinalifestyle.one/fashion-trends-2025-radical-intentionality/'
  },
  {
    id: '2',
    titleKey: 'blog_post_2_title',
    dateKey: 'blog_post_2_date',
    excerptKey: 'blog_post_2_excerpt',
    contentKey: 'blog_post_2_content',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1542601906990-b4d3fb778b09?q=80&w=800&auto=format&fit=crop`,
    authorId: 'julian-sinclair',
    date: '2026-01-15',
    dateModified: '2025-10-15',
    externalUrl: 'https://diary.constantinalifestyle.one/sustainable-fashion-eco-friendly-clothing/'
  },
  {
    id: '3',
    titleKey: 'blog_post_3_title',
    dateKey: 'blog_post_3_date',
    excerptKey: 'blog_post_3_excerpt',
    contentKey: 'blog_post_3_content',
    imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.LOOKBOOKS}virtual-lookbook_5.png`,
    authorId: 'julian-sinclair',
    date: '2026-03-05',
    dateModified: '2025-10-05',
    externalUrl: 'https://diary.constantinalifestyle.one/capsule-wardrobe-guide/'
  },
  {
    id: '4',
    titleKey: 'blog_post_4_title',
    dateKey: 'blog_post_4_date',
    excerptKey: 'blog_post_4_excerpt',
    contentKey: 'blog_post_4_content',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1617127365659-c47fa864d8bc?q=80&w=800&auto=format&fit=crop`,
    authorId: 'lukas-weber',
    date: '2025-10-01',
    dateModified: '2025-10-01',
    externalUrl: 'https://diary.constantinalifestyle.one/streetwear-2025-trends/'
  },
  {
    id: '5',
    titleKey: 'blog_post_5_title',
    dateKey: 'blog_post_5_date',
    excerptKey: 'blog_post_5_excerpt',
    contentKey: 'blog_post_5_content',
    imageUrl: `${CDN_URLS.UNSPLASH}photo-1558769132-cb1aea458c5e?q=80&w=800&auto=format&fit=crop`,
    authorId: 'heidi-steiner',
    date: '2025-09-25',
    dateModified: '2025-09-25',
    externalUrl: 'https://diary.constantinalifestyle.one/wardrobe-essentials-investment-pieces/'
  }
];
